import { TIME_RANGE_OPTIONS } from './timeRangeUtils'

export default {
  props: {
    value: {
      type: Object | Array,
      default: null,
    },
    context: {
      type: Object,
      default: Object,
    },
  },
  data () {
    return {
      defaultValue: {},
      dataTypes: [
        'money',
        'percentage',
        'number',
        'label',
        'id',
        'boolean',
        'date',
        'time',
        'datetime',
        'duration',
      ],
      timeRangeOptions: TIME_RANGE_OPTIONS.map(o => ({ ...o, })),
    }
  },
  computed: {
    inputs: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  mounted () {
    if (!this.inputs) {
      this.inputs = this.defaultValue
    }
  },
}
